import {Link as GatsbyLink, GatsbyLinkProps} from 'gatsby'
import styled from '@emotion/styled'

import * as styles from 'src/styles'

interface Props extends GatsbyLinkProps<any> {
  typography?:
    | 'headerXl'
    | 'header1'
    | 'header2'
    | 'header3'
    | 'header4'
    | 'lede'
    | 'body'
    | 'smallBody'
    | 'extraSmallBody'
}

export const PrimaryLink = styled(GatsbyLink)<Props>(
  ({theme}) => ({
    color: theme.colors.primary,
    textDecorationColor: theme.colors.primary,
    '&:active, &:hover': {
      color: theme.colors.primary,
    },
    '&:visited': {
      color: theme.colors.visitedLink,
      textDecorationColor: theme.colors.visitedLink,
    },
  }),
  ({typography}) => typography && styles.typography[typography]
)

export const Link = GatsbyLink
